import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DContext } from "../../../context/Datacontext";
import { IoReturnUpBackOutline } from "react-icons/io5";

export const ViewUser = () => {

    const { BeURL, alertHandler } = useContext(DContext);
    const location = useLocation();
    const navigate = useNavigate();

    const userId = location.state?.userId;

    const [user, setUser] = useState(null);
    const [role, setRole] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        if (!userId) return;

        const fetchUser = async () => {

            try {

                const res = await fetch(
                    `${BeURL}/fetch-user?userId=${userId}`,
                    {
                        method: "GET",
                        credentials: "include",
                    }
                );

                const data = await res.json();

                if (data?.success) {
                    setUser(data.user);
                    setRole(data.role);
                } else {
                    alertHandler(data.message);
                }

            } catch (error) {
                console.error("Error fetching user:", error);
            } finally {
                setLoading(false);
            }

        };

        fetchUser();

    }, [BeURL, userId, alertHandler]);


    if (!userId) {
        return (
            <div className="p-6 text-red-500">
                User ID not found
            </div>
        );
    }


    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-gray-600">
                Loading Profile...
            </div>
        );
    }


    return (
        <div className="min-h-screen bg-gray-50 p-6 space-y-5 rounded-xl border shadow-xl">
            {/* BACK BUTTON */}
            <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium"
            >
                <IoReturnUpBackOutline /> Back
            </button>
            {/* PROFILE HEADER */}
            <div className="bg-white rounded-2xl shadow-md border border-gray-200 p-8">

                <div className="flex flex-col md:flex-row items-center gap-8">

                    <img
                        src={
                            user?.avatar
                                ? `${BeURL}/uploads/${user.avatar}`
                                : "https://via.placeholder.com/150"
                        }
                        alt="avatar"
                        className="w-36 h-36 rounded-full object-cover border-4 border-primary-600"
                    />

                    <div className="flex-1 text-center md:text-left">

                        <h1 className="text-3xl font-bold text-gray-800">
                            {user?.fullName}
                        </h1>

                        <p className="text-primary-600 font-medium mt-1">
                            {user?.headline}
                        </p>

                        <div className="flex flex-wrap gap-4 mt-3 text-sm text-gray-600 justify-center md:justify-start">

                            <span>{user?.email}</span>

                            <span>{user?.contact}</span>

                            <span>{user?.location}</span>

                            <span className="font-medium text-primary-600">
                                {role?.toUpperCase()}
                            </span>

                        </div>

                    </div>

                </div>

            </div>


            {/* GRID SECTION */}
            <div className="grid lg:grid-cols-3 gap-8 mt-8">


                {/* LEFT SIDE */}
                <div className="lg:col-span-1 space-y-8">


                    {/* ABOUT */}
                    <div className="bg-white p-6 rounded-xl border shadow-sm">

                        <h2 className="text-lg font-semibold text-primary-600 border-b pb-2">
                            About
                        </h2>

                        <p className="text-gray-600 mt-3 text-sm leading-relaxed">
                            {user?.bio || "No bio added"}
                        </p>

                    </div>


                    {/* SKILLS */}
                    <div className="bg-white p-6 rounded-xl border shadow-sm">

                        <h2 className="text-lg font-semibold text-primary-600 border-b pb-2">
                            Skills
                        </h2>

                        <div className="flex flex-wrap gap-2 mt-4">

                            {user?.skills?.length > 0 ? (

                                user.skills.map((skill, i) => (

                                    <span
                                        key={i}
                                        className="px-3 py-1 text-xs bg-primary-50 text-primary-600 border border-primary-200 rounded-full"
                                    >
                                        {skill}
                                    </span>

                                ))

                            ) : (

                                <p className="text-gray-400 text-sm">
                                    No skills added
                                </p>

                            )}

                        </div>

                    </div>

                </div>



                {/* RIGHT SIDE */}
                <div className="lg:col-span-2 space-y-8">


                    {/* PROFESSIONAL INFO */}
                    <div className="bg-white p-6 rounded-xl border shadow-sm">

                        <h2 className="text-lg font-semibold text-primary-600 border-b pb-2">
                            Professional Info
                        </h2>

                        <div className="grid md:grid-cols-2 gap-4 mt-4 text-sm text-gray-700">

                            <p>
                                <span className="font-semibold">
                                    Experience:
                                </span>{" "}
                                {user?.experienceYears || 0} years
                            </p>

                            <p>
                                <span className="font-semibold">
                                    Teaching Language:
                                </span>{" "}
                                {user?.teachingLanguage}
                            </p>

                            <p>
                                <span className="font-semibold">
                                    Gender:
                                </span>{" "}
                                {user?.gender}
                            </p>

                            <p>
                                <span className="font-semibold">
                                    Website:
                                </span>{" "}
                                <a
                                    href={user?.website}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-primary-600 hover:underline"
                                >
                                    Visit
                                </a>
                            </p>

                        </div>

                    </div>



                    {/* EXPERIENCE */}
                    <div className="bg-white p-6 rounded-xl border shadow-sm">

                        <h2 className="text-lg font-semibold text-primary-600 border-b pb-2">
                            Experience
                        </h2>

                        <div className="mt-4 space-y-5">

                            {user?.experience?.length > 0 ? (

                                user.experience.map((exp) => (

                                    <div
                                        key={exp._id}
                                        className="border-l-4 border-primary-600 pl-4"
                                    >

                                        <h3 className="font-semibold">
                                            {exp.role}
                                        </h3>

                                        <p className="text-sm text-gray-500">
                                            {exp.company}
                                        </p>

                                        <p className="text-xs text-gray-400">
                                            {exp.years}
                                        </p>

                                        <p className="text-sm mt-1 text-gray-600">
                                            {exp.description}
                                        </p>

                                    </div>

                                ))

                            ) : (

                                <p className="text-gray-400 text-sm">
                                    No experience added
                                </p>

                            )}

                        </div>

                    </div>



                    {/* EDUCATION */}
                    <div className="bg-white p-6 rounded-xl border shadow-sm">

                        <h2 className="text-lg font-semibold text-primary-600 border-b pb-2">
                            Education
                        </h2>

                        <div className="mt-4 space-y-5">

                            {user?.education?.length > 0 ? (

                                user.education.map((edu) => (

                                    <div
                                        key={edu._id}
                                        className="border-l-4 border-primary-600 pl-4"
                                    >

                                        <h3 className="font-semibold">
                                            {edu.degree}
                                        </h3>

                                        <p className="text-sm text-gray-500">
                                            {edu.institute}
                                        </p>

                                        <p className="text-xs text-gray-400">
                                            {edu.year}
                                        </p>

                                        <p className="text-sm mt-1 text-gray-600">
                                            {edu.field}
                                        </p>

                                    </div>

                                ))

                            ) : (

                                <p className="text-gray-400 text-sm">
                                    No education added
                                </p>

                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};